<template>
  <div v-if="loading" class="loading">Aguarde ...</div>
  <div v-else class="container">
    <div class="text-left">
      <h3>
        <router-link to="/emails">Emails</router-link> » <router-link to="/email/c/0">Adicionar</router-link>
      </h3>
    </div>
    <table>
      <tr>
        <td>#</td>
        <td></td>
        <td></td>
        <td>Assunto</td>
        <td class="text-center">Enviados / Total</td>
        <td>Data</td>
      </tr>
      <tr v-for="email in emails">
        <td><a @click.prevent="select4edit(email.cod)" class="glyphicon glyphicon-pencil" title="Editar"></a></td>
        <td><a @click.prevent="select4list(email.cod)" class="glyphicon glyphicon-list" title="Lista de Destinatários"></a></td>
        <td><a @click.prevent="select4send(email.cod)" class="glyphicon glyphicon-envelope" title="Enviar para Lista"></a></td>
        <td>{{email.assunto}}</td>
        <td class="text-center">
          <b class="text-muted">
            <span class="text-success">{{email.enviados}}</span> / {{email.total}}
          </b>
        </td>
        <td>{{email.dt}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
  // import Mask from './Mask.js'
  export default {
    name: 'emailrel',
    data () {
      return {
        loading: false,
        emails: []
      }
    },
    methods: {
      load (params = '') {
        const url = './api/php/getemail.php'
        this.$http.post(url, JSON.stringify(params)).then(
          function (response) {
            console.log(response.body)
            if (response.body.status) {
              this.emails = response.body.rows
            } else {
              this.emails = []
            }
          },
          function (error) {
            console.log(error)
          }
        )
      },
      select4edit (cod) {
        this.$router.push({path: `/email/u/${cod}`})
      },
      select4send (cod) {
        this.$router.push({path: `/emails/${cod}`})
      }
    },
    created: function () {
      this.load()
    },
    watch: {
      '$route' (to, from) {
        this.load()
      }
    }
  }
</script>

<style scoped>
    .container {
        width: 80vw;
        margin: auto;
    }
    table {
      font: 12px sans-serif;
      color: #333;
      border-collapse: collapse;
      outline: 2px solid #333;
      text-align: left;
      width: 100%;
    }
    table tr {
      background: #fcfcfc;
    }
    table tr:nth-child(2n+1) {
      background: #f1f1f1;
    }
    table tr:hover{
      background: #ccc;
    }
    table tr:first-child {
      background: #333;
      color: #fff;
      text-transform: uppercase;
    }
    table tr td {
      padding: 5px;
    }
    table tr td small {
      color: #777;
    }
    a.glyphicon {
      text-decoration: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/EmailRel.vue